module.exports = __webpack_public_path__ + "static/media/ni.b7c2f51b.svg";